import { useNormalizedRouterSearchParams } from "hooks"
import { isNil } from "lodash"
import { useMemo } from "react"
import { useGetKioskConfig } from "providers/venue/modules/data/kiosk-config/useGetKioskConfig"

import { KIOSK_CONFIG_NAME_KEY } from "./constants"
import {
  get as getPersistValue,
  set as setPersistValue,
} from "utils/persist_store"

export const useKioskConfig = () => {
  const { kioskName: currentKioskName } = useNormalizedRouterSearchParams<{
    kioskName: string
  }>()
  const kioskConfigName = useMemo(() => {
    const prevKioskName = getPersistValue(KIOSK_CONFIG_NAME_KEY)

    if (isNil(currentKioskName)) return prevKioskName

    if (prevKioskName !== currentKioskName)
      setPersistValue(KIOSK_CONFIG_NAME_KEY, currentKioskName)

    return currentKioskName || prevKioskName
  }, [currentKioskName])

  const { data: kioskConfig } = useGetKioskConfig(kioskConfigName)

  return {
    kioskConfigName,
    kioskConfig,
  }
}
